import isFunction from './isFunction';
export default function isStatelessFunction(test) {
    return isFunction(test) && !(test.prototype && test.prototype.isReactComponent);
}
//# sourceMappingURL=isStatelessFunction.js.map